export default function NotFoundPage() {
    return <h2>404: Page not found</h2>;
}